(function () {
  "use strict";
  const R = window.FTCRenderer, S = window.FTCStudioRenderer, G = window.FTCGiftTemplates;
  const root = document.getElementById("ftc-studio");
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = "true";
  const $ = (id) => root.querySelector("#" + id);
  const shopifyMode = root.dataset.shopify === "true";
  const routeRoot = root.dataset.routeRoot || "/";
  let variants = {};
  try { variants = JSON.parse($("studioProducts")?.textContent || "{}"); } catch (_) { /* Unavailable variants keep checkout disabled. */ }
  const defaults = {
    title: "", text: shopifyMode ? "" : "You make ordinary days\nfeel like the good old days.", author: "", detail: "", date: "", note: "", link: "", showQr: false,
    font: "Instrument Serif", fontSize: 88, lineHeight: 1.2, align: "center", position: "middle", margin: 10,
    bold: false, italic: false, uppercase: false, quoteMarks: false, border: "none", divider: false,
    background: "#fff0f0", ink: "#713943", product: "framedA3", frameColor: "black", preset: "classic",
    photoData: "", photoName: "", hasPhoto: false, photoLayout: "above", photoEffect: "original", photoZoom: 1, photoX: 50, photoY: 50, photoHeight: 36, photoOverlay: 40
  };
  const presets = [
    { id: "classic", name: "Classic", style: { font: "Instrument Serif", background: "#fff0f0", ink: "#713943", fontSize: 88, align: "center", bold: false, italic: false, border: "none" } },
    { id: "bold", name: "Bold", style: { font: "Inter", background: "#fff5a3", ink: "#29282a", fontSize: 92, align: "left", bold: true, italic: false, border: "none" } },
    { id: "handwritten", name: "Handwritten", style: { font: "Caveat", background: "#ffffff", ink: "#285399", fontSize: 105, align: "center", bold: false, italic: false, border: "none" } },
    { id: "garden", name: "Soft green", style: { font: "Fraunces", background: "#eaf5ec", ink: "#235546", fontSize: 81, align: "center", bold: false, italic: true, border: "line" } },
    { id: "editorial", name: "Editorial", style: { font: "Playfair Display", background: "#ffffff", ink: "#24242a", fontSize: 92, align: "left", bold: true, italic: false, border: "double" } },
    { id: "midnight", name: "After dark", style: { font: "Instrument Serif", background: "#24242a", ink: "#fafafa", fontSize: 88, align: "center", bold: false, italic: true, border: "none" } }
  ];
  const palettes = { rose: ["#fff0f0", "#713943"], mono: ["#ffffff", "#202124"], green: ["#eaf5ec", "#235546"], sun: ["#fff5a3", "#29282a"], dark: ["#24242a", "#fafafa"], blue: ["#edf5ff", "#285399"] };
  const numberRanges = { fontSize: [38,148], lineHeight: [1.05,1.65], margin: [6,18], photoZoom: [1,3], photoX: [0,100], photoY: [0,100], photoHeight: [20,48], photoOverlay: [0,80] };
  const choices = { font: S.fonts, align: ["left","center","right"], position: ["top","middle","bottom"], border: ["none","line","double"], product: ["poster","framedA3","canvas","digital"], photoLayout: ["above","below","background"], photoEffect: ["original","mono","warm"], preset: presets.map(p => p.id).concat("custom") };
  choices.product.push('posterA2','poster5070','framed','framed4050','framedCanvas');
  choices.frameColor = ['black','white','natural','brown'];
  const frameColors = {black:['Black','#292a29'],white:['White','#f5f5f2'],natural:['Natural wood','#c49c6f'],brown:['Dark brown','#654735']};
  function colorsFor(product) { return product === 'framedCanvas' ? ['black','natural','brown'] : product.startsWith('framed') ? ['black','white','natural'] : []; }
  function selectedVariant(design = state) { return variants[design.product + (colorsFor(design.product).length && design.frameColor !== 'black' ? '_' + design.frameColor : '')]; }
  const textLimits = { title: 90, text: 1200, author: 70, detail: 60, date: 60, note: 240, link: 2000, photoName: 200 };
  let state = { ...defaults }, photo = null, photoVersion = 0, layout = null, activeTab = "words", view = "product", showGuides = false;
  let queued = false, saveTimer = 0, historyTimer = 0, toastTimer = 0, dirty = false, dbPromise = null, qrCache = null, qrUrl = "";
  let history = [JSON.stringify(state)], historyIndex = 0, ordering = false, qualityDpi = null;

  function normalize(raw) {
    const clean = { ...defaults };
    for (const [key, limit] of Object.entries(textLimits)) if (typeof raw[key] === "string") clean[key] = raw[key].slice(0, limit);
    for (const [key, allowed] of Object.entries(choices)) if (allowed.includes(raw[key])) clean[key] = raw[key];
    for (const [key, [low, high]] of Object.entries(numberRanges)) if (Number.isFinite(raw[key])) clean[key] = S.clamp(raw[key], low, high);
    for (const key of ["bold","italic","uppercase","quoteMarks","divider","showQr"]) if (typeof raw[key] === "boolean") clean[key] = raw[key];
    for (const key of ["background", "ink"]) if (typeof raw[key] === "string" && /^#[\da-f]{6}$/i.test(raw[key])) clean[key] = raw[key].toLowerCase();
    if (typeof raw.photoData === "string" && /^data:image\/(png|jpeg|webp);base64,/.test(raw.photoData) && raw.photoData.length < 29_000_000) clean.photoData = raw.photoData;
    clean.hasPhoto = !!clean.photoData || raw.hasPhoto === true;
    if (colorsFor(clean.product).length && !colorsFor(clean.product).includes(clean.frameColor)) clean.frameColor = 'black';
    return clean;
  }

  function designHash(design = state) {
    const payload = { app: "FrameThisComment Studio", version: 1, design: { ...design, photoData: "", hasPhoto: !!design.photoData || design.hasPhoto } };
    return btoa(String.fromCharCode(...new TextEncoder().encode(JSON.stringify(payload))));
  }

  async function restoreHash() {
    if (!location.hash) return false;
    try {
      const raw = JSON.parse(new TextDecoder().decode(Uint8Array.from(atob(location.hash.slice(1)), char => char.charCodeAt(0))));
      if (raw.app !== "FrameThisComment Studio" || raw.version !== 1 || !raw.design) throw new Error("Choose a Studio design link.");
      state = normalize({ ...raw.design, photoData: "" });
      const handoff = new URLSearchParams(location.search).get("handoff");
      if (handoff && /^[a-z0-9-]{10,60}$/i.test(handoff)) {
        try {
          const key = "ftc-studio-entry:" + handoff, photoData = sessionStorage.getItem(key);
          if (photoData) { state = normalize({ ...state, photoData }); sessionStorage.removeItem(key); }
        } catch (_) { /* The order link still requests the original image. */ }
      }
      if (state.hasPhoto && !state.photoData) {
        try {
          const db = await database();
          const draft = await new Promise((resolve, reject) => {
            const request = db.transaction("drafts").objectStore("drafts").get("current");
            request.onsuccess = () => resolve(request.result); request.onerror = () => reject(request.error);
          });
          if (draft) {
            const saved = normalize(draft);
            // Only restore an image belonging to this exact design, never a different draft.
            if (JSON.stringify({ ...saved, photoData: "" }) === JSON.stringify(state)) state = saved;
          }
        } catch (_) { /* Missing originals remain blocked at checkout. */ }
      }
      await loadPhoto(); history = [JSON.stringify(state)]; historyIndex = 0; syncControls(); scheduleRender();
      if (state.photoData) await saveDraft();
    } catch (_) { toast("This design link could not be opened. Open your saved design instead.", true); }
    return true;
  }

  function currentDesignUrl(design = state) {
    const base = shopifyMode ? location.origin + routeRoot + "pages/create-from-scratch" : location.href.split("?")[0].split("#")[0];
    return base + "#" + designHash(design);
  }

  function toast(message, error = false) {
    $("toast").textContent = message; $("toast").dataset.error = error; $("toast").hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => { $("toast").hidden = true; }, 4500);
  }

  function database() {
    if (!dbPromise) dbPromise = new Promise((resolve, reject) => {
      const request = indexedDB.open("ftc-scratch-studio", 1);
      request.onupgradeneeded = () => request.result.createObjectStore("drafts");
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
    return dbPromise;
  }

  async function saveDraft() {
    try {
      const db = await database(), saved = JSON.parse(JSON.stringify(state));
      await new Promise((resolve, reject) => {
        const tx = db.transaction("drafts", "readwrite");
        tx.objectStore("drafts").put(saved, "current"); tx.oncomplete = resolve; tx.onerror = () => reject(tx.error);
      });
      $("saveStatus").textContent = "Saved on this device";
    } catch (_) { $("saveStatus").textContent = "Use Save design"; }
  }

  async function restoreDraft() {
    try {
      const db = await database();
      const saved = await new Promise((resolve, reject) => {
        const request = db.transaction("drafts").objectStore("drafts").get("current");
        request.onsuccess = () => resolve(request.result); request.onerror = () => reject(request.error);
      });
      if (saved && !dirty) { state = normalize(saved); await loadPhoto(); history = [JSON.stringify(state)]; historyIndex = 0; syncControls(); scheduleRender(); $("saveStatus").textContent = "Saved on this device"; }
    } catch (_) { $("saveStatus").textContent = "Use Save design"; }
  }

  function recordHistory() {
    clearTimeout(historyTimer);
    const snapshot = JSON.stringify(state);
    if (snapshot === history[historyIndex]) return;
    history = history.slice(0, historyIndex + 1); history.push(snapshot);
    if (history.length > 40) history.shift();
    historyIndex = history.length - 1; updateHistoryButtons();
  }

  function updateHistoryButtons() { $("undo").disabled = historyIndex === 0 && JSON.stringify(state) === history[0]; $("redo").disabled = historyIndex >= history.length - 1; }

  function changed(immediate = false) {
    dirty = true;
    if (shopifyMode) window.history.replaceState(null, "", "#" + designHash());
    if (immediate) recordHistory(); else { clearTimeout(historyTimer); historyTimer = setTimeout(recordHistory, 450); }
    clearTimeout(saveTimer); $("saveStatus").textContent = "Saving..."; saveTimer = setTimeout(saveDraft, 500);
    scheduleRender(); updateHistoryButtons();
  }

  async function goHistory(delta) {
    recordHistory(); const next = historyIndex + delta;
    if (next < 0 || next >= history.length) return;
    historyIndex = next; state = JSON.parse(history[historyIndex]);
    await loadPhoto(); syncControls(); dirty = true; scheduleRender(); saveDraft(); updateHistoryButtons();
  }

  function setTab(tab, focus = false) {
    activeTab = tab;
    root.querySelectorAll("[data-tab]").forEach(button => { const selected = button.dataset.tab === tab; button.setAttribute("aria-selected", selected); button.tabIndex = selected ? 0 : -1; $("panel-" + button.dataset.tab).hidden = !selected; });
    if (focus) $("tab-" + tab).focus();
  }

  function syncControls() {
    const colors = colorsFor(state.product);
    if (colors.length && !colors.includes(state.frameColor)) state.frameColor = 'black';
    root.querySelectorAll("[data-field]").forEach(control => { const value = state[control.dataset.field]; if (control.type === "checkbox") control.checked = value; else if (control !== document.activeElement) control.value = value; });
    root.querySelectorAll("[data-choice]").forEach(button => button.setAttribute("aria-pressed", state[button.dataset.choice] === button.dataset.value));
    root.querySelectorAll("[data-toggle]").forEach(button => button.setAttribute("aria-pressed", !!state[button.dataset.toggle]));
    root.querySelectorAll("button[data-view]").forEach(button => button.setAttribute("aria-pressed", button.dataset.view === view));
    root.querySelectorAll("[data-preset]").forEach(button => button.setAttribute("aria-pressed", state.preset === button.dataset.preset));
    root.querySelectorAll("[data-palette]").forEach(button => button.setAttribute("aria-pressed", palettes[button.dataset.palette][0] === state.background && palettes[button.dataset.palette][1] === state.ink));
    root.querySelectorAll("[data-output]").forEach(output => {
      const key = output.dataset.output, n = state[key];
      output.textContent = key === "lineHeight" ? n.toFixed(2) : key === "photoZoom" ? n.toFixed(1) + "x" : ["margin","photoX","photoY","photoHeight","photoOverlay"].includes(key) ? n + "%" : n;
    });
    $("textCount").textContent = state.text.length + " / 1200";
    $("backgroundValue").textContent = state.background.toUpperCase(); $("inkValue").textContent = state.ink.toUpperCase();
    $("imageControls").hidden = !photo; $("imageInfo").hidden = !photo;
    $("photoHeightSetting").hidden = state.photoLayout === "background"; $("overlaySetting").hidden = state.photoLayout !== "background";
    if (photo) { $("imageThumb").src = state.photoData; $("imageName").textContent = state.photoName || "Your image"; $("imageDimensions").textContent = `${photo.naturalWidth} x ${photo.naturalHeight} px`; }
    $("artShell").dataset.view = view; $("artShell").dataset.product = state.product;
    $("artShell").dataset.mockup = R.productFor(state.product).mockup;
    $("artShell").style.setProperty('--frame-colour', frameColors[state.frameColor][1]);
    $('frameColours').hidden = !colors.length;
    root.querySelectorAll('[data-choice="frameColor"]').forEach(button => { button.hidden = !colors.includes(button.dataset.value); });
    const sizes = state.product.startsWith('poster') ? [['poster','A3'],['posterA2','A2'],['poster5070','50 x 70 cm']] : ['framedA3','framed','framed4050'].includes(state.product) ? [['framedA3','A3'],['framed','30 x 40 cm'],['framed4050','40 x 50 cm']] : [];
    $('sizeOptions').hidden = !sizes.length;
    const sizeSelect = $('productSize');
    if (sizeSelect.dataset.family !== (sizes[0]?.[0] || '')) {
      sizeSelect.replaceChildren(...sizes.map(([value,label]) => new Option(label,value)));
      sizeSelect.dataset.family = sizes[0]?.[0] || '';
    }
    sizeSelect.value = state.product;
    root.querySelectorAll('[data-choice="product"]').forEach(button => {
      const key = button.dataset.value;
      button.setAttribute('aria-pressed', key === state.product || key === 'poster' && state.product.startsWith('poster') || key === 'framedA3' && ['framed','framed4050'].includes(state.product));
    });
    const product = R.productFor(state.product), size = R.exportSize(state.product);
    const label = product.label;
    $("formatLabel").textContent = label; $("formatDimensions").textContent = product.sizeNote.split(" \u00b7 ")[0];
    $("specFormat").textContent = label; $("specPixels").textContent = size.join(" x ") + " px";
    $("specBleed").textContent = state.product === "digital" ? "None" : `${Math.round(product.bleed / 300 * 25.4)} mm`;
    const viewButton = root.querySelector('button[data-view="product"]');
    viewButton.textContent = ['frame','floating-frame'].includes(product.mockup) ? "In a frame" : product.mockup === "canvas" ? "Canvas" : product.mockup === "paper" ? "Paper" : "Artwork";
    viewButton.hidden = product.mockup === "none";
    $("designSummary").textContent = state.author ? `Words worth keeping, from ${state.author}.` : "A few words. A proper keepsake.";
    $("missingPhoto").hidden = !state.hasPhoto || !!photo;
    if (shopifyMode) {
      const selected = selectedVariant();
      $("orderPrice").textContent = selected?.price || "Unavailable";
      $("orderStudio").disabled = ordering || !selected?.available;
      $("deliveryNote").textContent = state.product === "digital" ? "Prepared individually and emailed after payment, not an instant download. No shipping." : root.dataset.deliveryNote || "Made to order. Delivery estimate and shipping total are shown at checkout.";
      const sizeNote = ['canvas','framedCanvas'].includes(state.product) ? '30 x 40 cm' : product.sizeNote.split(' · ')[0];
      $("productInclusions").textContent = state.product === 'digital' ? 'Clean 2400 x 3000 px PNG. No watermark. No physical item.'
        : state.product === 'framedCanvas' ? `${sizeNote} canvas, floating wooden frame and hanging kit. No glazing.`
        : state.product.startsWith('framed') ? `${sizeNote} print, wooden frame, acrylic glazing and hanging kit. Arrives assembled.`
        : state.product === 'canvas' ? `${sizeNote} stretched canvas, 2 cm profile and hanging kit. No outer frame.`
        : `${sizeNote} print on 200 gsm matte paper. Frame not included.`;
      for (const key of ['poster','framedA3','canvas','framedCanvas','digital']) {
        const button = root.querySelector(`[data-choice="product"][data-value="${key}"]`);
        if (!button) continue;
        const previewKey = comparisonProduct(key);
        const color = colorsFor(previewKey).includes(state.frameColor) ? state.frameColor : 'black';
        const value = selectedVariant({...state,product:previewKey,frameColor:color});
        let price = button.querySelector(".format-price");
        if (!price) { price = document.createElement("span"); price.className = "format-price"; button.insertBefore(price, button.lastElementChild); }
        price.textContent = value?.price || 'Unavailable';
      }
    }
    updateHistoryButtons();
  }

  function getQr() {
    if (!state.showQr) { $("qrError").hidden = true; return null; }
    let url = "";
    try { const parsed = new URL(state.link.trim()); if (["https:", "http:"].includes(parsed.protocol)) url = parsed.href; } catch (_) { /* The inline field shows the error. */ }
    $("qrError").hidden = !!url;
    $("qrError").textContent = "Enter a complete http or https link.";
    if (!url) return null;
    if (url === qrUrl) return qrCache;
    try {
      const code = window.qrcode(0, "M"); code.addData(url, "Byte"); code.make();
      const count = code.getModuleCount(), cells = [];
      for (let row = 0; row < count; row++) for (let col = 0; col < count; col++) cells.push(code.isDark(row, col));
      qrCache = { count, cells }; qrUrl = url; return qrCache;
    } catch (_) { $("qrError").hidden = false; $("qrError").textContent = "This link is too long. Try a shorter link."; return null; }
  }

  function render() {
    queued = false; syncControls();
    const canvasProduct = view === 'product' && ['canvas','framedCanvas'].includes(state.product);
    const product = R.productFor(state.product);
    const ratio = canvasProduct ? product.trim[0] / product.trim[1] : R.aspectRatio(state.product), stage = $("stage");
    const framed = view === "product" && ['frame','floating-frame'].includes(R.productFor(state.product).mockup);
    const chrome = framed ? 58 : view === "product" && state.product === "canvas" ? 10 : 0;
    const width = Math.max(100, Math.min(stage.clientWidth - 56 - chrome, (stage.clientHeight - 100 - chrome) * ratio));
    const height = width / ratio, dpr = Math.min(devicePixelRatio || 1, 2);
    const canvas = $("artwork"); canvas.width = Math.round(width * dpr); canvas.height = Math.round(height * dpr);
    canvas.style.width = width + "px"; canvas.style.height = height + "px";
    const previewState = !state.text.trim() && !photo ? { ...state, text: "Your words,\nyour way." } : state;
    layout = canvasProduct
      ? R.renderTrimPreview(canvas.getContext('2d'), state.product, canvas.width, canvas.height, (ctx,w,h) => S.renderArtwork(ctx,previewState,w,h,photo,getQr()))
      : S.renderArtwork(canvas.getContext("2d"), previewState, canvas.width, canvas.height, photo, getQr());
    const guide = $("safeGuides"); guide.hidden = !showGuides;
    const borderPadding = framed ? state.product === 'framedCanvas' ? 18 : 14 : view === "product" && state.product.startsWith('poster') ? 5 : 0;
    const trimUnit = 1000 / layout.fullW;
    const gx = canvasProduct ? (layout.box.x - product.bleed * trimUnit) / (product.trim[0] * trimUnit) : layout.box.x / 1000;
    const gy = canvasProduct ? (layout.box.y - product.bleed * trimUnit) / (product.trim[1] * trimUnit) : layout.box.y / layout.height;
    guide.style.left = (borderPadding + width * gx) + 'px'; guide.style.top = (borderPadding + height * gy) + 'px';
    guide.style.width = width * layout.box.w / (canvasProduct ? product.trim[0] * trimUnit : 1000) + 'px';
    guide.style.height = height * layout.box.h / (canvasProduct ? product.trim[1] * trimUnit : layout.height) + 'px';
    const quality = $("qualityNotice"); quality.hidden = true; qualityDpi = null;
    if (photo && layout.photoBox) {
      const effective = Math.round(300 * layout.photoCrop.w / (layout.photoBox.w / 1000 * layout.fullW)); qualityDpi = effective;
      if (effective < 150 && state.product !== "digital") { quality.hidden = false; quality.dataset.level = effective < 100 ? "low" : "caution"; quality.textContent = `This image may look blurry in print (about ${effective} dpi at this crop). A larger original or less zoom will help.`; }
    }
    $("qualityAckRow").hidden = !shopifyMode || state.product === "digital" || qualityDpi === null || qualityDpi >= 150;
    $("fitNotice").hidden = !layout.fitAdjusted && layout.fits;
    $("fitNotice").textContent = layout.fits ? "The words have been made a little smaller to keep everything on the page." : "There is too much content for this layout. Reduce the image height or shorten the details before exporting.";
    $("fitNotice").dataset.level = layout.fits ? "caution" : "low";
    for (const preset of presets) {
      const thumb = root.querySelector(`[data-preset="${preset.id}"] canvas`);
      S.renderArtwork(thumb.getContext("2d"), { ...previewState, ...preset.style }, thumb.width, thumb.height, photo, getQr());
    }
    root.querySelectorAll('[data-format-preview]').forEach(thumb => {
      const key = comparisonProduct(thumb.dataset.formatPreview), format = R.productFor(key);
      const design = {...previewState,product:key};
      const isCanvas = ['canvas','framedCanvas'].includes(key);
      thumb.width = 120;
      thumb.height = Math.round(120 / (isCanvas ? format.trim[0]/format.trim[1] : R.aspectRatio(key)));
      thumb.parentElement.dataset.mockup = format.mockup;
      const color = colorsFor(key).includes(state.frameColor) ? state.frameColor : 'black';
      thumb.parentElement.style.setProperty('--frame-colour',frameColors[color][1]);
      if (isCanvas) R.renderTrimPreview(thumb.getContext('2d'), key, thumb.width, thumb.height, (ctx,w,h) => S.renderArtwork(ctx,design,w,h,photo,getQr()));
      else S.renderArtwork(thumb.getContext('2d'),design,thumb.width,thumb.height,photo,getQr());
    });
    if ($("zoomDialog").open) drawZoom();
  }

  function comparisonProduct(key) {
    if (key === 'poster' && state.product.startsWith('poster')) return state.product;
    if (key === 'framedA3' && ['framedA3','framed','framed4050'].includes(state.product)) return state.product;
    return key;
  }

  root.querySelectorAll('[data-choice="product"]').forEach(button => {
    const scene = document.createElement('span'); scene.className = 'format-scene'; scene.setAttribute('aria-hidden','true');
    const art = document.createElement('span'); art.className = 'format-art';
    const canvas = document.createElement('canvas'); canvas.dataset.formatPreview = button.dataset.value;
    art.append(canvas); scene.append(art); button.querySelector('svg,i')?.remove(); button.prepend(scene);
  });

  function scheduleRender() { if (!queued) { queued = true; requestAnimationFrame(render); } }

  async function loadPhoto() {
    const version = ++photoVersion;
    if (!state.photoData) { photo = null; return; }
    const image = new Image(); image.src = state.photoData;
    try { await image.decode(); if (version === photoVersion) photo = image; }
    catch (_) { if (version === photoVersion) { photo = null; state.photoData = ""; state.photoName = ""; toast("The saved image could not be opened. Add it again.", true); } }
  }

  async function uploadPhoto(file) {
    if (!file || !["image/jpeg","image/png","image/webp"].includes(file.type)) { toast("Choose a JPG, PNG or WebP image.", true); return; }
    if (file.size > (shopifyMode ? 19 : 20) * 1024 * 1024) { toast(shopifyMode ? "Choose an image smaller than 19 MB." : "Choose an image smaller than 20 MB.", true); return; }
    try {
      const data = await new Promise((resolve, reject) => { const reader = new FileReader(); reader.onload = () => resolve(reader.result); reader.onerror = reject; reader.readAsDataURL(file); });
      const image = new Image(); image.src = data; await image.decode();
      if (image.naturalWidth * image.naturalHeight > 50_000_000) { toast("This image is too large to edit here. Try a smaller version.", true); return; }
      const restoring = state.hasPhoto && !photo;
      recordHistory(); ++photoVersion; photo = image; state.photoData = data; state.photoName = file.name; state.hasPhoto = true;
      if (!restoring) { state.photoZoom = 1; state.photoX = 50; state.photoY = 50; }
      $("qualityAck").checked = false;
      changed(true); toast("Image added.");
    } catch (_) { toast("That image could not be opened. Try another file.", true); }
    $("photoFile").value = "";
  }

  function download(blob, filename) {
    const url = URL.createObjectURL(blob), link = document.createElement("a"); link.href = url; link.download = filename; link.click(); setTimeout(() => URL.revokeObjectURL(url), 60000);
  }

  async function exportPng(full) {
    if (full && shopifyMode) return;
    if (state.hasPhoto && !photo) { toast("Add the original image before exporting.", true); setTab("image"); return; }
    if (!state.text.trim() && !photo) { toast("Add some words or an image first.", true); setTab("words"); $("text").focus(); return; }
    const qr = getQr();
    if (state.showQr && !qr) { toast("Add a valid link or turn off the QR code.", true); setTab("words"); root.querySelector(".optional-section").open = true; $("link").focus(); return; }
    const button = full ? $("exportFull") : $("downloadPreview"); button.disabled = true;
    try {
      await G.ensureFonts(); await document.fonts.ready;
      const [w, h] = R.exportSize(state.product), canvas = document.createElement("canvas");
      canvas.width = full ? w : 900; canvas.height = full ? h : Math.round(900 * h / w);
      const ctx = canvas.getContext("2d"), result = S.renderArtwork(ctx, state, canvas.width, canvas.height, photo, qr);
      if (!result.fits) { toast("Shorten the details or reduce the image height before exporting.", true); return; }
      if (!full) S.watermark(ctx, canvas.width, canvas.height);
      const blob = await new Promise(resolve => canvas.toBlob(resolve, "image/png"));
      if (!blob) throw new Error("Could not create the PNG. Try again.");
      download(blob, `framethiscomment-scratch-${state.product}${full ? "-full" : "-preview"}.png`);
      toast(full ? `Clean PNG exported: ${w} x ${h} px.` : "Preview downloaded.");
    } catch (error) { toast(error.message || "Could not export the image.", true); }
    finally { button.disabled = false; }
  }

  function saveDesign() {
    recordHistory(); download(new Blob([JSON.stringify({ app: "FrameThisComment Studio", version: 1, design: state }, null, 2)], { type: "application/json" }), "framethiscomment-design.ftc.json");
    saveDraft(); toast("Design saved, including your image.");
  }

  async function importDesign(file) {
    if (!file) return;
    try {
      if (file.size > 30_000_000) throw new Error("That design file is too large.");
      const raw = JSON.parse(await file.text());
      if (raw.app !== "FrameThisComment Studio" || raw.version !== 1 || !raw.design || typeof raw.design !== "object") throw new Error("Choose a FrameThisComment Studio design file.");
      recordHistory(); state = normalize(raw.design); await loadPhoto(); syncControls(); changed(true); toast("Your design is open.");
    } catch (error) { toast(error.message || "Could not open this design.", true); }
    $("designFile").value = "";
  }

  function applyPreset(id) {
    const preset = presets.find(item => item.id === id);
    recordHistory(); Object.assign(state, preset.style, { preset: id, lineHeight: 1.2, position: "middle", margin: 10, uppercase: false });
    syncControls(); changed(true);
  }

  function drawZoom() {
    const canvas = $("zoomCanvas"), ratio = R.aspectRatio(state.product);
    const maxW = Math.min(840, innerWidth - 72), maxH = innerHeight - 148;
    const width = Math.min(maxW, maxH * ratio);
    canvas.width = Math.round(width * 2); canvas.height = Math.round(width / ratio * 2);
    canvas.style.width = width + "px"; canvas.style.height = width / ratio + "px";
    S.renderArtwork(canvas.getContext("2d"), state, canvas.width, canvas.height, photo, getQr());
  }

  function sourceFile(design) {
    if (!design.photoData) return null;
    const [header, value] = design.photoData.split(","), type = header.match(/^data:(image\/(?:png|jpeg|webp));base64$/)?.[1];
    if (!type) throw new Error("Add your original image again.");
    const file = new File([Uint8Array.from(atob(value), char => char.charCodeAt(0))], design.photoName || "source-image.png", { type });
    if (file.size > 19 * 1024 * 1024) throw new Error("Choose an image smaller than 19 MB before ordering.");
    return file;
  }

  function isUpload(value) {
    try { const url = new URL(value); return url.protocol === "https:" && url.hostname === "cdn.shopify.com" && url.pathname.includes("/uploads/"); } catch (_) { return false; }
  }

  async function orderStudio() {
    if (!shopifyMode || ordering) return;
    $("orderError").hidden = true;
    if (state.hasPhoto && !photo) { toast("Add your original image before ordering.", true); setTab("image"); return; }
    if (!state.text.trim() && !photo) { toast("Add some words or an image first.", true); setTab("words"); $("text").focus(); return; }
    const qr = getQr();
    if (state.showQr && !qr) { toast("Add a valid link or turn off the QR code.", true); setTab("words"); root.querySelector(".optional-section").open = true; return; }
    render();
    if (!layout.fits) { toast("Shorten the details or reduce the image height before ordering.", true); return; }
    if (state.product !== "digital" && qualityDpi !== null && qualityDpi < 150 && !$("qualityAck").checked) { $("orderError").textContent = "Please confirm that your image may print blurry, or choose a larger image."; $("orderError").hidden = false; $("qualityAck").focus(); return; }
    const design = normalize(state), variant = selectedVariant(design);
    if (!variant?.available) { toast("This format is unavailable. Choose another format.", true); return; }
    const digital = design.product === "digital", url = currentDesignUrl(design), property = "_Design link";
    const button = $("orderStudio"); ordering = true; button.disabled = true; root.setAttribute("aria-busy", "true");
    let addedKey = "";
    try {
      button.textContent = "Preparing order...";
      if (!window.FTCCartPrivacy) throw new Error("Please reload the editor before ordering.");
      await window.FTCCartPrivacy.sanitizeCart();
      const original = sourceFile(design);
      const data = new FormData(); data.set("id", String(variant.id)); data.set("quantity", "1");
      data.set(`properties[${property}]`, url); data.set("properties[Artwork style]", "Start from scratch");
      if (colorsFor(design.product).length) data.set('properties[Frame colour]', frameColors[design.frameColor][0]);
      if (variant.uid) data.set('properties[_Gelato product UID]', variant.uid);
      data.set("properties[_Editor]", "FTC Studio v1"); data.set("properties[_Studio request]", crypto.randomUUID());
      data.set("properties[_Fulfilment]", "Render after payment");
      if (digital) data.set("properties[Delivery]", "Clean 2400 x 3000 PNG by email after payment");
      if (original) data.set("properties[_Source image]", original, original.name);
      const campaign = new URLSearchParams(location.search).get("utm_campaign") || "";
      if (/^gift_(wedding_anniversary|kids_quotes|business_gifts)$/.test(campaign)) data.set("properties[Gift campaign]", campaign);
      button.textContent = "Adding to cart...";
      const response = await fetch(routeRoot + "cart/add.js", { method: "POST", credentials: "same-origin", body: data });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || "Could not add your artwork to the cart.");
      addedKey = result.key;
      if (result.properties?.[property] !== url) throw new Error("Shopify did not save the design link. Please try again.");
      if (original && !isUpload(result.properties?.["_Source image"])) throw new Error("Shopify did not attach the source image. Please try again.");
      const attributes = { __design_url: url, design_url: "", print_url: "" };
      if (/^gift_(wedding_anniversary|kids_quotes|business_gifts)$/.test(campaign)) attributes.gift_campaign = campaign;
      const updated = await fetch(routeRoot + "cart/update.js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes }) });
      const cart = await updated.json();
      if (!updated.ok || cart.attributes?.design_url || cart.attributes?.print_url) throw new Error("The design could not be saved to the order. Please try again.");
      location.href = routeRoot + "checkout";
    } catch (error) {
      let cleanupFailed = false;
      if (addedKey) {
        try {
          const removed = await fetch(routeRoot + "cart/change.js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: addedKey, quantity: 0 }) });
          if (!removed.ok) cleanupFailed = true;
        } catch (_) { cleanupFailed = true; }
      }
      $("orderError").textContent = (error.message || "Could not start checkout. Please try again.") + (cleanupFailed ? " Check your cart before trying again." : "");
      $("orderError").hidden = false; ordering = false; button.textContent = "Order"; button.disabled = false; root.removeAttribute("aria-busy");
    }
  }

  $("presets").innerHTML = presets.map(preset => `<button class="preset" data-preset="${preset.id}" aria-pressed="false"><div class="preset-art"><canvas width="100" height="141" aria-label="${preset.name} artwork"></canvas></div><span>${preset.name}</span></button>`).join("");
  root.querySelectorAll("[data-field]").forEach(control => control.addEventListener("input", () => {
    const key = control.dataset.field;
    state[key] = control.type === "checkbox" ? control.checked : numberRanges[key] ? Number(control.value) : control.value;
    if (!["title","text","author","detail","date","note","link","showQr","quoteMarks","product"].includes(key)) state.preset = "custom";
    if (["margin","photoLayout","photoZoom","photoX","photoY","photoHeight","product"].includes(key)) $("qualityAck").checked = false;
    changed(control.type === "checkbox" || control.tagName === "SELECT");
  }));
  root.addEventListener("click", event => {
    const button = event.target.closest("button"); if (!button) return;
    if (button.dataset.tab) setTab(button.dataset.tab);
    if (button.dataset.choice) { recordHistory(); state[button.dataset.choice] = button.dataset.value; if (!['product','frameColor'].includes(button.dataset.choice)) state.preset = "custom"; $("qualityAck").checked = false; changed(true); }
    if (button.dataset.toggle) { recordHistory(); state[button.dataset.toggle] = !state[button.dataset.toggle]; state.preset = "custom"; changed(true); }
    if (button.dataset.palette) { recordHistory(); [state.background, state.ink] = palettes[button.dataset.palette]; state.preset = "custom"; changed(true); }
    if (button.dataset.view) { view = button.dataset.view; scheduleRender(); }
    if (button.dataset.preset) applyPreset(button.dataset.preset);
  });
  $("undo").addEventListener("click", () => goHistory(-1)); $("redo").addEventListener("click", () => goHistory(1));
  $("editWords").addEventListener("click", () => { setTab("words"); root.querySelector(".editor").scrollIntoView({ block: "start" }); $("text").focus({ preventScroll: true }); });
  $("backToPreview").addEventListener("click", () => root.querySelector(".preview").scrollIntoView({ block: "start" }));
  $("orderStudio").addEventListener("click", orderStudio);
  $("copyLink").addEventListener("click", async () => { try { await navigator.clipboard.writeText(currentDesignUrl()); toast(state.hasPhoto ? "Link copied. The original image must be added when reopening." : "Design link copied."); } catch (_) { toast("Could not copy the link. Save your design instead.", true); } });
  $("saveDesign").addEventListener("click", saveDesign); $("openDesign").addEventListener("click", () => $("designFile").click());
  $("designFile").addEventListener("change", event => importDesign(event.target.files[0]));
  $("photoFile").addEventListener("change", event => uploadPhoto(event.target.files[0]));
  $("removeImage").addEventListener("click", () => { recordHistory(); ++photoVersion; state.photoData = ""; state.photoName = ""; state.hasPhoto = false; photo = null; changed(true); });
  $("resetCrop").addEventListener("click", () => { recordHistory(); Object.assign(state, { photoX: 50, photoY: 50, photoZoom: 1 }); syncControls(); changed(true); });
  $("resetStyle").addEventListener("click", () => applyPreset("classic"));
  $("exampleWords").addEventListener("click", () => { recordHistory(); state.text = "Dad, when I grow up\nI'm going to be tired too."; state.author = "Noor"; state.detail = "Age 5"; state.title = ""; state.note = ""; state.date = ""; syncControls(); changed(true); });
  $("clearWords").addEventListener("click", () => { recordHistory(); for (const key of ["title","text","author","detail","date","note"]) state[key] = ""; syncControls(); changed(true); $("text").focus(); });
  $("downloadPreview").addEventListener("click", () => exportPng(false)); $("exportFull").addEventListener("click", () => exportPng(true));
  $("showGuides").addEventListener("change", event => { showGuides = event.target.checked; scheduleRender(); });
  $("openZoom").addEventListener("click", () => { $("zoomDialog").showModal(); drawZoom(); });
  $("closeZoom").addEventListener("click", () => $("zoomDialog").close());
  $("zoomDialog").addEventListener("click", event => { if (event.target === $("zoomDialog")) { const r = $("zoomDialog").getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) $("zoomDialog").close(); } });
  root.querySelector(".editor-tabs").addEventListener("keydown", event => {
    if (!["ArrowLeft","ArrowRight","Home","End"].includes(event.key)) return;
    event.preventDefault(); const tabs = ["words","style","image","format"], i = tabs.indexOf(activeTab);
    setTab(tabs[event.key === "Home" ? 0 : event.key === "End" ? 3 : (i + (event.key === "ArrowRight" ? 1 : 3)) % 4], true);
  });
  root.addEventListener("keydown", event => {
    if (!(event.ctrlKey || event.metaKey)) return;
    if (event.key.toLowerCase() === "s") { event.preventDefault(); saveDesign(); }
    if (event.key.toLowerCase() === "z" && !event.target.matches("input,textarea")) { event.preventDefault(); goHistory(event.shiftKey ? 1 : -1); }
  });
  $("dropzone").addEventListener("dragover", event => { event.preventDefault(); $("dropzone").classList.add("dragging"); });
  $("dropzone").addEventListener("dragleave", () => $("dropzone").classList.remove("dragging"));
  $("dropzone").addEventListener("drop", event => { event.preventDefault(); $("dropzone").classList.remove("dragging"); uploadPhoto(event.dataTransfer.files[0]); });
  window.addEventListener("resize", scheduleRender);
  window.addEventListener("pagehide", () => { if (dirty) saveDraft(); });
  $("checkoutBar").hidden = !shopifyMode; $("exportFull").hidden = shopifyMode; $("copyLink").hidden = !shopifyMode;
  window.lucide.createIcons({ root }); syncControls(); scheduleRender();
  restoreHash().then(async hasHash => {
    if (!hasHash) {
      await restoreDraft();
      const product = new URLSearchParams(location.search).get('product');
      if (choices.product.includes(product)) { state.product = product; syncControls(); scheduleRender(); }
      const requested = new URLSearchParams(location.search).get('variant');
      const entry = requested && Object.entries(variants).find(([,value]) => String(value.id) === requested);
      if (entry) {
        const [product,frameColor='black'] = entry[0].split('_');
        if (choices.product.includes(product)) { Object.assign(state,{product,frameColor}); syncControls(); scheduleRender(); }
      }
    }
  });
  G.ensureFonts().then(scheduleRender);
})();
